import { ADD_ANIMATED_THUMBNAIL_DATA } from './actions';

export const reducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_ANIMATED_THUMBNAIL_DATA:
      return {
        ...state,
        [action.payload.videoId]: action.payload.storyboard,
      };

    default:
      return state;
  }
};
